export const variants = {
	h1: {
		fontSize: '6rem',
		lineHeight: 1.167,
		tracking: '-2%'
	},
	h2: {
		fontSize: '3.75rem',
		lineHeight: 1.2,
		tracking: '-2%'
	},
	h3: {
		fontSize: '3rem',
		lineHeight: 1.167,
		tracking: '-2%'
	},
	h4: {
		fontSize: '2.125rem',
		lineHeight: 1.23,
		tracking: '-2%'
	},
	h5: {
		fontSize: '2rem',
		lineHeight: 1.33
	},
	h6: {
		fontSize: '1.25rem',
		lineHeight: 1.6
	},
	body1: {
		fontSize: '1rem',
		fontFamily: 'Inter,sans-serif',
		lineHeight: 1.5
	},
	subtitle1: {
		fontSize: '1rem',
		fontFamily: 'Inter,sans-serif',
		lineHeight: 1.75
	},
	subtitle2: {
		fontSize: '0.875rem',
		fontFamily: 'Inter,sans-serif',
		lineHeight: 1.57
	},
	body2: {
		fontSize: '0.875rem',
		fontFamily: 'Inter,sans-serif',
		lineHeight: 1.43
	},
	caption: {
		fontSize: '0.75rem',
		fontFamily: 'Inter,sans-serif',
		lineHeight: 1.66
	}
}

export const fontWeights = {
	regular: 400,
	medium: 600,
	bold: 700,
	heavy: 800
}
